import debounce from "lodash.debounce";
import React, { useRef } from "react";

export const useDebounce = (...params: Parameters<typeof debounce>) => {
  const ref = useRef(debounce(...params));
  return ref.current;
};
